import React from "react";
import "./AppHeader.css";

export default function AppHeader({ title, right, onBack }) {
  return (
    <div className="hdr">
      <button className="hdr-back" onClick={onBack} aria-label="Back">←</button>
      <div className="hdr-title">{title}</div>
      <div className="hdr-right">{right}</div>
    </div>
  );
}
